import { useRef, useEffect, useState } from 'react';
import { PerspectiveCamera } from '@react-three/drei';
import * as THREE from 'three';

const Camera = (props) => {
    
    const { pan = 0, tilt = 0, defaultZoom = 1, panoId } = props;
    
    const cameraRef = useRef();
    const [position, setPosition] = useState([0, 0, 0]);
    
    const getPosition = (tilt, pan) => {
        let position = new THREE.Vector3(0, 0, 0);
        if (pan < 0) {
            pan = 360 + pan;
        }
        position.setFromSphericalCoords(1000,
            THREE.MathUtils.degToRad(90 - tilt),
            THREE.MathUtils.degToRad(- pan)
        );

        return position;
    };
    
    useEffect(() => {
        if (!cameraRef.current) return;

        const { x, y, z } = getPosition(tilt, pan);
        setPosition([ x, y, z ]);

        cameraRef.current.position.set(x, y, z).normalize().negate();
        cameraRef.current.updateProjectionMatrix();
        console.log('update camera ', {pan, tilt});

    }, [pan, tilt, defaultZoom, panoId]);
    
    return <PerspectiveCamera makeDefault {...props} fov={61} ref={cameraRef} 
        position={position} zoom={defaultZoom} />
};

export default Camera;